import React from 'react';
import PropTypes from 'prop-types';
import { createHtmlPortalNode, InPortal, OutPortal } from 'react-reverse-portal';
import { WrapWrapper, CardWrapperOverride, CarouselWrapper, FinalCardWrapper } from './Wrap.style';
import { withTheme } from 'styled-components';
import TopPerformersDataContainer from '../TopPerformers/containers/TopPerformersDataContainer';
import PlayerOfTheGameDataContainer from '../PlayerOfTheGame/containers/PlayerOfTheGameDataContainer';
import VideoCarouselDataContainer from '../VideoCarousel/containers/VideoCarouselDataContainer';
import DataVizDataContainer from '../VideoCarousel/containers/DataVizDataContainer';
import RecapDataContainer from '../Recap/RecapDataContainer';
import { HighlightsDataContainer } from '../Highlights/containers/HighlightsDataContainer';
import TeamComparisonDataContainer from '../TeamComparison/TeamComparisonDataContainer';
import MoreCoverageDataContainer from '../MoreCoverage/containers/MoreCoverageDataContainer';
import { finalViewsTypes } from '../themes/finalViewsTypes';

const { SINGLENARROW } = finalViewsTypes;
const videoCarouselPortalNode = createHtmlPortalNode();
const MobileContentCard = ({ children }) => <CardWrapperOverride paddingOverride={'16px'} marginOverride={'0px'}>{children}</CardWrapperOverride>;

const potgTrackingProps = {
    componentName: ['Final']
};

MobileContentCard.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ])
};

const Wrap = ({ viewType }) => {
    const isMobile = viewType === SINGLENARROW;
    return (
        <WrapWrapper $viewType={viewType}>
            <InPortal node={videoCarouselPortalNode}>
                <VideoCarouselDataContainer />
            </InPortal>
            <CarouselWrapper $viewType={viewType} $marginOverride={!isMobile && '16px 16px 24px'} $paddingOverride={'var(--gameday-section-padding-sm) 0px'}>
                <OutPortal node={videoCarouselPortalNode} />
            </CarouselWrapper>
            <CardWrapperOverride paddingOverride={'0px'} maxHeightOverride={'100%'}>
                <RecapDataContainer isMobile={isMobile} />
                <HighlightsDataContainer isMobile={isMobile}/>
            </CardWrapperOverride>
            <FinalCardWrapper $viewType={viewType}>
                <PlayerOfTheGameDataContainer trackingProps={potgTrackingProps} ContentContainer={isMobile ? MobileContentCard : undefined} />
            </FinalCardWrapper>
            <CarouselWrapper $viewType={viewType} $marginOverride={isMobile ? '24px 0 0 0' : '24px 16px 0'} $paddingOverride={'var(--gameday-section-padding-sm)'}>
                <TopPerformersDataContainer isMobile={isMobile} />
            </CarouselWrapper>
            <FinalCardWrapper $viewType={viewType}>
                <TeamComparisonDataContainer types={['game']} ContentContainer={isMobile ? MobileContentCard : undefined} />
            </FinalCardWrapper>
            <CarouselWrapper $viewType={viewType} $marginOverride={!isMobile ? '16px 16px 24px' : '24px 0 0'} $paddingOverride={'var(--gameday-section-padding-sm) 0px'}>
                <DataVizDataContainer />
            </CarouselWrapper>
            <FinalCardWrapper $viewType={viewType} $paddingOverride={'var(--gameday-section-padding-sm)'}>
                <MoreCoverageDataContainer ContentContainer={isMobile ? MobileContentCard : undefined} />
            </FinalCardWrapper>
        </WrapWrapper>
    );
};

Wrap.propTypes = {
    viewType: PropTypes.string
};

export default withTheme(Wrap);
